import * as React from 'react';

import FormRequiredMark from '../form-required-mark/FormRequiredMark';

import { __t, applyTranslations } from 'utils/language';

import './form-footer.scss';

applyTranslations(require('./form-footer.i18n.json'));

type Props = {
  showRequiredMarkExplanation?: boolean
};

class FormFooter extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { showRequiredMarkExplanation } = this.props;

    return (
      <footer className="form-footer">
        {
          showRequiredMarkExplanation &&
            <span className="form-footer__explanation">
              <FormRequiredMark />
              {__t('form_footer.explanation_for_required_mark')}
            </span>
        }
      </footer>
    );
  }
}

export default FormFooter;
